import { jsx as _jsx } from "react/jsx-runtime";
import { getObjectHash } from '@iotv/datamodel-core';
import { useEffect, useRef, useState } from 'react';
const debug = process.env.REACT_APP_DEBUG && false;
export const TimelineChart = ({ dataTable, options, fragmentProps, listenerFns }) => {
    'use no memo';
    // Error: Cannot access refs during render
    const chartRef = useRef(null);
    const [chart, setChart] = useState(null);
    const optionsHash = getObjectHash(options);
    const { select } = listenerFns ?? {};
    /**
     * Due to an intermittent `google.visualization.Timeline is not a constructor` error,
     * (which mainly shows up when using Hot-Reload whilst developing),
     * we check if it is construtable (i.e. loaded) before doing anything
     *
     * https://stackoverflow.com/a/70810697
     *  */
    const drawChart = (dataTable) => {
        const target = chartRef.current;
        if (target &&
            dataTable &&
            !!google.visualization.Timeline &&
            typeof google.visualization.Timeline === 'function' &&
            !!google.visualization.Timeline.prototype &&
            !!google.visualization.Timeline.prototype.constructor) {
            let localChart = chart;
            if (!localChart) {
                localChart = new google.visualization.Timeline(target);
            }
            // >> HERE MOVED BEFORE INTERNET WENT OFF!!!
            if (select) {
                // TODO: deal with listener lifecycle as per Google Maps v4
                google.visualization.events.removeAllListeners(localChart);
                const listener = google.visualization.events.addListener(localChart, 'select', select(localChart, dataTable));
            }
            google.visualization.events.addListener(localChart, 'error', (e) => {
                console.log(`Error Listener caught error, debug`, e.message, dataTable.toJSON());
                throw new Error(`Error Listener caught error`);
            });
            setChart(localChart);
            localChart.draw(dataTable, options);
        }
        else {
            debug && console.log('Graph did not update');
        }
    };
    useEffect(() => {
        if (dataTable) {
            debug && console.log(`Timeline used effect on data rows ${dataTable.getNumberOfRows()}. cols ${dataTable.getNumberOfColumns()}`);
            drawChart(dataTable);
        }
        return () => {
            if (chart) {
                google.visualization.events.removeAllListeners(chart);
            }
        };
    }, [dataTable]);
    useEffect(() => {
        if (dataTable) {
            debug && console.log(`Timeline used effect on optionsHash`);
            setChart(null);
            drawChart(dataTable);
        }
    }, [optionsHash]);
    return _jsx("div", { ref: chartRef, ...fragmentProps });
};
